module.exports = __webpack_public_path__ + "img/mouse.366c75e3.png";